//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SelfBuildingSquareSpinner',
  props: {
    animationDuration: {
      type: Number,
      "default": 6000
    },
    size: {
      type: Number,
      "default": 40
    },
    color: {
      type: String,
      "default": '#fff'
    }
  },
  data: function data() {
    return {
      squaresNum: 9
    };
  },
  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: "".concat(-this.initialTopPosition, "px"),
        height: "".concat(this.size, "px"),
        width: "".concat(this.size, "px")
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: "".concat(this.squareSize, "px"),
        width: "".concat(this.squareSize, "px"),
        top: "".concat(this.initialTopPosition, "px"),
        marginRight: "".concat(this.squareSize / 3, "px"),
        marginTop: "".concat(this.squareSize / 3, "px"),
        animationDuration: "".concat(this.animationDuration, "ms"),
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(Object.assign({
          animationDelay: "".concat(delayModifier * delaysMultipliers[i], "ms")
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
};